import styled from 'styled-components/macro'

export const FocusContent = styled.div`
    width: auto;
    float: left;
    color: #999999;
    font-size: 12px;
    font-family: 'Gordita-Regular';
    position: absolute;
    left: 12px;
    top: 19px;
    line-height: 10px;
    transition: 0.26s ease-in;

    .target.customTip {
        pointer-events: initial;
        cursor: pointer;
        padding-left: 3px;
        position: relative;
        top: 0px;
        pointer-events: all;
    }
    .target.customTip svg {
        width: 9px;
        height: 9px;
        position: relative;
        top: 0px;
        right: 0px;
        color: #999;
        fill: #999;
        pointer-events: all;
    }
`
export const DraftInputWrapper = styled.div`
    width: 100%;
    float: left;

    .dialog_input_edit_true.dialog_context_input_edit_true {
        background: #ffffff 0% 0% no-repeat padding-box;
        border: 1px solid #b9b9b9;
        border-radius: 6px;
        min-height: 48px;
        cursor: text;
        position: relative;
        z-index: 0;
        .public-DraftStyleDefault-block.public-DraftStyleDefault-ltr {
            padding: 0px 7px 3px 7px;
        }
    }
    .DraftEditor-root {
        font-size: 12px;
        font-family: 'Gordita-Regular';
        color: #000000;
        padding-top: 20px;
    }

    .DraftEditor-editorContainer {
        min-height: 18px;
    }
    .input_selected_dialog ${FocusContent} {
        top: 8px;
        font-size: 10px;
        transition: 0.26s ease-out;
        line-height: 10px;
    }
    .focus_input ${FocusContent} {
        top: 8px;
        font-size: 10px;
        transition: 0.26s ease-out;
        line-height: 10px;
    }

    .faq_adaptive_card {
        .faq_adaptive_card_radios {
            display: inline-flex;
            p {
                padding: 10px;
                padding-left: 0px;
            }
        }
        .adaptive_card {
            padding: 0px;
        }
    }
    :first-child{
        margin-top: 0px;
    }
`
